import { HOST } from '@env';

export function getOrganizationPrefix(): string {
  return location.host.replace(HOST, '').split('.')[0];
}
